import { colors } from '@components/theme';
import { Box, Grid, makeStyles, Popover, TextField } from '@material-ui/core';
import React from 'react';
import { PickerProps, Shift } from './model';
import { _AmPmTo24Hour } from './utils';

export const Picker = ({ width, initData, open, handleClose }: PickerProps) => {
  const classes = useStyles();

  const hourRef = React.useRef<HTMLInputElement>(null);
  const minuteRef = React.useRef<HTMLInputElement>(null);
  const shiftRef = React.useRef<HTMLDivElement>(null);

  return (
    <Popover
      open={Boolean(open)}
      onEnter={() => {
        if (hourRef.current) hourRef.current.value = initData.hour;
        if (minuteRef.current) minuteRef.current.value = initData.minute;
        if (shiftRef.current) shiftRef.current.innerHTML = initData.shift;
      }}
      onClose={() =>
        handleClose(
          _AmPmTo24Hour({
            hour: hourRef.current ? hourRef.current.value : '00',
            minute: minuteRef.current ? minuteRef.current.value : '00',
            shift: shiftRef.current?.innerHTML as Shift
          })
        )
      }
      anchorEl={open as Element}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center'
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center'
      }}
    >
      <Box width={width} height={40}>
        <Grid container style={{ height: '100%' }}>
          <Grid item xs={4} style={{ height: '100%' }}>
            <input
              ref={hourRef}
              type='number'
              min={1}
              max={12}
              step={1}
              defaultValue={initData.hour}
              className={classes.numberInput}
            />
          </Grid>
          <Grid item xs={4}>
            <input
              ref={minuteRef}
              type='number'
              min={0}
              max={59}
              step={1}
              defaultValue={initData.minute}
              className={classes.numberInput}
            />
          </Grid>
          <Grid
            item
            xs={4}
            justifyContent='center'
            alignItems='center'
            style={{ display: 'flex', cursor: 'pointer' }}
            onClick={() => {
              if (shiftRef.current) {
                if (shiftRef.current.innerHTML === Shift.AM) {
                  shiftRef.current.innerHTML = Shift.PM;
                } else {
                  shiftRef.current.innerHTML = Shift.AM;
                }
              }
            }}
          >
            <div ref={shiftRef} className={classes.shiftInput}>
              {initData.shift}
            </div>
          </Grid>
        </Grid>
      </Box>
    </Popover>
  );
};

const useStyles = () => {
  return makeStyles({
    numberInput: {
      display: 'block',
      width: '100%',
      height: '100%',
      textAlign: 'center',
      outline: 'none',
      '&:focus': {
        border: `1px solid ${colors.primary.main}`
      },
      '&::-webkit-inner-spin-button': {
        width: '24px',
        height: '36px'
      }
    },
    shiftInput: {
      border: 'none',
      textAlign: 'center'
    }
  })();
};
